exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#silentbox-gallery .silentbox-item{display:none}", ""]);

// exports
